module.exports = __webpack_public_path__ + "img/ZH.00d7b6d9.png";